import React from 'react';
import { PropTypes } from 'prop-types';
import { IoClose } from 'react-icons/io5';

const Toast = ({ message, type = 'error', onClose }) => {
  return (
    <div className={`single-toast toast-${type}`}>
      <span className={`toast-message-${type}`}>{message}</span>
      <button
        type="button"
        className="toast-button"
        onClick={onClose}
      >
        <IoClose size={20} color="black" />
      </button>
    </div>
  );
};

Toast.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['success', 'error', 'info', 'warning', 'neutral']),
  onClose: PropTypes.func.isRequired,
};

export default Toast;
